import './skeleton.css'

const RollingGraphLoader = () => {
  return (
    <div className='bg-white flex flex-col pb-6 w-full'>
      <div className='font-[500] leading-[150%] pb-3 relative'>
        <div className='skeleton h-5 w-1/2 mb-2 rounded-[4px]' />
      </div>

      <div className='w-full flex gap-3'>
        <div className='flex flex-1'>
          <div className='skeleton w-full h-10 rounded-[12px]' />
        </div>

        <div className='flex flex-1'>
          <div className='skeleton w-full h-10 rounded-[12px]' />
        </div>
      </div>

      <div className='w-full relative pt-5'>
        <div className='h-[316px] w-full skeleton rounded-[12px]'></div>
      </div>

      <div className='w-full flex gap-1 relative pt-6'>
        <div className='h-10 w-10 skeleton rounded-[12px]'></div>
        <div className='h-[54px] flex flex-1 w-full skeleton rounded-[12px]'></div>
      </div>
    </div>
  )
}

export default RollingGraphLoader
